// https://material-table.com/#/docs/all-props

import MaterialTable, { Options } from "material-table"
import React from "react"
import tableIcons from "./tableIcons"

interface IColumn {
    title: string,
    field: string
}

interface IEditable {
    isEditable?: (rowData: any) => boolean
    isDeletable?: (rowData: any) => boolean
    onRowAdd?: (newData: any) => Promise<void>
    onRowUpdate?: (newData: any, oldData?: any) => Promise<void>
    onRowDelete?: (oldData: any) => Promise<void>
}

interface ITableComponentProps {
    title?: string,
    loading?: boolean,
    totalCount?: number,
    page?: number,
    columns: IColumn[],
    data: any[],
    editable?: IEditable,
    options?: Options,
    onChangePage?: (page: number) => void
    onOrderChange?: (orderBy: number, orderDirection: ("asc" | "desc")) => void
    onSearchChange?: (searchText: string) => void
    components?: any
    actions?: any
}

const defaultOptions: Options = {
    toolbarButtonAlignment: "right",
    pageSize: 20,
    pageSizeOptions: [20],
    headerStyle: {
        whiteSpace: "nowrap",
    },
    maxBodyHeight: "65vh",
    minBodyHeight: "65vh",
    emptyRowsWhenPaging: false,
    actionsColumnIndex: 100,
}

const Table = (props: ITableComponentProps) => {
    const { options } = props
    const newOptions = { ...defaultOptions, ...options, search: false }
    return (
        <MaterialTable
            icons={tableIcons}
            options={newOptions}
            style={{ padding: "0 8px" }}
            localization={{
                header: {
                    actions: "操作",
                },
                body: {
                    editRow: {
                        saveTooltip: "确认",
                        cancelTooltip: "取消",
                        deleteText: "确认删除该行数据",
                    },
                    editTooltip: "编辑",
                    addTooltip: "创建",
                    deleteTooltip: "删除",
                    emptyDataSourceMessage: "暂无数据",
                },
            }}
            {...props}
        />
    )
}

export default Table
